export var ChoreLength;
(function (ChoreLength) {
    ChoreLength["SHORT"] = "SHORT";
    ChoreLength["MEDIUM"] = "MEDIUM";
    ChoreLength["LONG"] = "LONG";
})(ChoreLength || (ChoreLength = {}));
